<template>
    <span
            class="VDateTimeSelectPicker"
    >
        <span
                @click="returnDateFromHistory"
                class="return-history"
                :class="{'return-history_disabled':!history.length}"
        >
          <font-awesome-icon icon="fa-solid fa-arrow-left"/></span>
        <VSelect
                :options="presetsWithCustom"
                :active-index="currentPresetIndex"
                :item="{}"
                :class="{'VSelect_datepicker': isShowDropdown && !isPresetMode || isPresetMode && isShowDatatimepicker}"
                @updateItem="choosePreset"
                @clickedButton="clickedSelect"
                @showDropDown="showDropDown"
                :is-show-menu="this.isPresetMode"
                show-property="text"
                @closed="closed"
        >
            <VButton
                    :is-active="isShowDropdown"
            >{{ showText }}</VButton>
            
            <template
                    #dropdown-bottom
                    v-if="'utc' in localDates"
            >
                 <div class="VDateTimeSelectPicker-sidebar">
                    <div class="VDateTimeSelectPicker-sidebar__title">
                        Time:
                    </div>
                    <div class="VDateTimeSelectPicker-sidebar__content">
                        <VToggle
                                :checked="localDates.utc"
                                :is-vertical-toggle="true"
                                @click="updateUtc"
                        ></VToggle>
                        <span class="VDateTimeSelectPicker-sidebar__content-text">
                        <span>Local</span>
                        <span>UTC</span>
                            </span>
                    </div>
                </div>
            </template>
        </VSelect>
        <VDateTimePicker
                :dates="localDates"
                :range="isRangeDatapicker"
                :choosed-preset="choosedPreset"
                :disabledDate="disabledDate"
                ref="vdatepicker"
                @updateUtc="updateUtc"
                @change="updateDates"
                @choosePreset="choosePreset"
                @updateChoosedDate="updateChoosedDate"
        ></VDateTimePicker>
    </span>
</template>

<script>
    import {getDataTimeRangePresets, getCustomRange, getObjectFromArray} from '@/helpers/dateTimeHelper';

    export default {
        name: 'VDateTimeSelectPicker',
        model: {
            prop: 'dates',
            event: 'change',
        },
        props: {
            history: {
                type: Array,
                default: () => getDataTimeRangePresets(),
            },
            presets: {
                type: Array,
                default: () => getDataTimeRangePresets(),
            },
            dates: {
                type: Object,
                default: () => {
                },
            },
        },
        data() {
            return {
                localDates: {},
                isShowDropdown: false,
                isShowDatatimepicker: false,
                isRangeDatapicker: true,
                choosedPreset: {},
                choosedDate: {},
                disabledDate: (date) => date > new Date(),
            };
        },
        methods: {
            updateChoosedDate(value){
                this.choosedDate = value;
            },
            returnDateFromHistory() {
                if (this.history.length) {
                    this.$emit('returnDateFromHistory', this.localDates);
                }
            },
            showDropDown(isShow) {
                if (this.isPresetMode) {
                    this.isShowDropdown = isShow;
                    this.choosedPreset = null;
                }
            },
            closed() {
                if (this.isPresetMode) {
                    this.isShowDropdown = false;
                }
                if (!this.isShowDatatimepicker && JSON.stringify(this.dates) !==
                    JSON.stringify(this.localDates)) {
                    this.$emit('change', this.localDates);
                }
            },
            checkIsUtcExist() {
                if (!('utc' in this.dates)) {
                    const newDates = _.cloneDeep(this.dates);
                    newDates.utc = false;
                    this.localDates = _.cloneDeep(newDates);
                } else {
                    this.localDates = _.cloneDeep(this.dates);
                }
            },
            updateUtc() {
                const newDates = _.cloneDeep(this.localDates);
                newDates.utc = !newDates.utc;
                this.localDates = _.cloneDeep(newDates);
            },
            choosePreset(preset) {
                const newDates = {
                    ...getObjectFromArray(preset.dates, this.localDates.utc),
                    preset: preset.text,
                };
                newDates.utc = this.localDates.utc;
                if (preset.text === 'Since') {
                    this.localDates.start = this.choosedDate.start;
                    if (this.choosedDate.end){
                        this.localDates.end = this.choosedDate.end;
                    }
                } else if (preset.text === 'Custom Range') {
                    this.localDates.start = this.choosedDate.start;
                }
                
                this.choosedPreset = preset;
                if (preset.text === 'Since') {
                    this.openDatapicker(false);
                } else {
                    if (JSON.stringify(this.dates) !== JSON.stringify(newDates)) {
                        if (preset.text === 'Custom Range') {
                            this.openDatapicker();
                        } else {
                            this.$emit('change', newDates);
                        }
                    }
                    if (this.isPresetMode && this.isShowDatatimepicker && !this.isShowDropdown) {
                        this.isShowDropdown = true;
                    } else {
                        this.isShowDropdown = false;
                    }
                }
            },
            clickedSelect() {
                const preset = this.presetsWithCustom.find((preset) => preset.text === this.dates.preset);
                if (this.dates.preset) {
                    this.choosedPreset = preset;
                }
                if (!this.isPresetMode) {
                    this.isShowDropdown = true;
                    const isRange = !!(this.dates.start && this.dates.end && (preset ? preset.text !== 'Since' : true));
                    this.openDatapicker(isRange);
                } else {
                    this.isShowDatatimepicker = false;
                }
            },
            updateDates(dates) {
                this.$emit('change', dates);
                this.isShowDropdown = false;
            },
            openDatapicker(isRange = true) {
                this.isRangeDatapicker = isRange;
                this.isShowDatatimepicker = true;
                this.$nextTick(() => {
                    this.$refs.vdatepicker.openPopup();
                });
            },
        },
        computed: {
            isPresetMode() {
                return !!this.dates.preset && this.dates.preset !== 'Since';
            },
            currentPresetIndex() {
                if (this.isPresetMode) {
                    return this.presetsWithCustom.findIndex((preset) => preset.text === this.dates.preset);
                }
                return -1;
            },
            presetsWithCustom() {
                return [...this.presets, getCustomRange(this.dates)];
            },
            showText() {
                if (this.dates && this.dates.preset && this.dates.preset.length) {
                    if (this.dates.preset.toLowerCase() === 'since') {
                        return `Since ${this.$moment(this.dates.start, 'YYYY-MM-DD').format('DD/MM/YYYY')}`;
                    }
                    return this.dates.preset;
                } else if (this.dates.start && this.dates.end) {
                    const formatedPeriod = {
                        start: this.$moment(this.dates.start, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        end: this.$moment(this.dates.end, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    };
                    return `${formatedPeriod.start} - ${formatedPeriod.end}`;
                }
                return 'Choose date';
            },
        },
        watch: {
            dates: {
                immediate: true,
                handler(dates) {
                    this.localDates = _.cloneDeep(dates);
                    this.checkIsUtcExist();
                },
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
  .VDateTimeSelectPicker {
    position: relative;

    .return-history {
      position: absolute;
      left: 3px;
      z-index: 1;
      cursor: pointer;

      &_disabled {
        opacity: 0.2;
        cursor: not-allowed;
      }
    }

    &-sidebar {

      color: $dark-blue-color;

      display: flex;
      flex-direction: column;

      margin-left: -8px;
      width: 55px;

      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;

      &__title {
        font-weight: 700;
        font-size: 15px;
        margin-bottom: 7px;
      }

      &__content {
        display: flex;
        height: 37px;
        width: 29px;

        &-text {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-weight: 500;
          margin-left: -2px;
          align-items: flex-start;
        }
      }
    }

    ::v-deep {
      .VToggle {
        padding-left: 5px;
        padding-right: 5px;
      }

      .VDateTimePicker {
        height: 1px;
        width: 1px;
        visibility: hidden;
      }

      .mx-datepicker {
        height: 1px;
      }

      .VButton-select {
        font-weight: bold;

        &::before {
          z-index: 0;
        }
      }

      .VSelect-dropdown {
        box-shadow: 0 5px 6px 0 rgb(133 126 207 / 30%);
        max-height: 450px;

        &__li {
          color: $dark-blue-color;

          &_active {
            background-color: #6e94e9;
            color: white;
          }
        }
      }
    }

    .VSelect_datepicker {
      ::v-deep {
        .VButton-select::before {
          box-shadow: 1px 6px 6px rgb(0 0 0 / 18%);
          width: calc(100% + 2px);
        }
      }
    }
  }
</style>
